<template>
  <div class="main">
    <el-form>
      <el-form-item>
        <div class="content">
          <el-descriptions :title="textDict.title" :column="1">
            <template slot="extra">
              <el-link type="danger" :underline="false">
                {{
                form.pay_result
                }} 
              </el-link>
            </template>
            <el-descriptions-item :label="textDict.product_name">{{ form.product_name }}</el-descriptions-item>
            <el-descriptions-item :label="textDict.custom_content">{{ form.custom_content }}</el-descriptions-item>
            <el-descriptions-item :label="textDict.game_name">{{ form.game_name }}</el-descriptions-item>
            <el-descriptions-item :label="textDict.server_name">{{ form.server_name }}</el-descriptions-item>
            <el-descriptions-item :label="textDict.roleid">{{ form.roleid }}</el-descriptions-item>
            <el-descriptions-item :label="textDict.pay_title">{{ form.pay_title }}({{ form.pay_way }})</el-descriptions-item>
            <el-descriptions-item :label="textDict.money">{{ form.money }} {{ form.currency }}</el-descriptions-item>
            <el-descriptions-item :label="textDict.order_id">{{ form.order_id }}</el-descriptions-item>
            <el-descriptions-item :label="textDict.pay_time">{{ form.pay_time }}</el-descriptions-item>
            <el-descriptions-item
              :label="textDict.coupon_code"
              v-if="form.coupon_code"
            >{{ form.coupon_code }}({{ form.coupon_ratio }}%)</el-descriptions-item>
            <el-descriptions-item :label="textDict.all_ratio">{{ form.all_ratio }}%</el-descriptions-item>
          </el-descriptions>
          <el-button
            style="width: 100%; margin-bottom: 10px; display: block"
            type="primary"
            @click="back"
            round
          >{{ textDict.button.back }}</el-button>
          <el-button
            style="width: 100%; margin-bottom: 10px; display: block; margin-left: 0;"
            type="primary"
            @click="againRecahrge"
            round
          >{{ textDict.button.againRecahrge }}</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { postSubmitOrder } from "@/api/index.js";
import dict from "@/dict/index.js"
export default {
  data() {
    return {
      form: {
        pay_result: "",
        game_name: "",
        server_name: "",
        roleid: "",
        pay_title: "",
        money: "",
        order_id: "",
        pay_time: "",
        currency: "",
      },
      textDict: dict.detail
    };
  },
  created() {
    let formData = Object.entries(this.$route.query);
    if (formData.length > 0) {
      this.form = this.$route.query;
    } else {
      this.$router.push("/index");
    }
  },
  methods: {
    back() {
      this.$router.push("/index");
    },
    async againRecahrge() {
      try {
        let res = await postSubmitOrder(this.form);
        location.href = res.data.pay_url;                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              v  
      } catch (error) {
        this.$message.error("Server Error " + error);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  background-color: #f4f5f4;
  height: 100%;
}

.content {
  background-color: #fff;
  margin: 10px auto;
  padding: 10px;
  width: 400px;
}
</style>